/* Aubelys · sections aub-cal-* : galerie (miniatures, flèches), offres (prix affiché), ajout au panier (tiroir du thème). */
(function () {
  'use strict';
  /* le fichier peut être inclus par plusieurs sections : une seule exécution, sinon chaque clic partirait plusieurs fois */
  if (window.aubCalInit) return;
  window.aubCalInit = true;
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return [].slice.call((r || document).querySelectorAll(s)); };
  var root = (window.Shopify && Shopify.routes ? Shopify.routes.root : '/');
  var eur = function (c) { return (c / 100).toFixed(2).replace('.', ',') + ' €'; };

  /* galerie : miniatures + flèches */
  $$('[data-aubk-gal]').forEach(function (g) {
    var tr = $('.aubk-gal__track', g), th = $$('.aubk-thumbs__list button', g);
    if (!tr) return;
    var idx = function () { return Math.round(tr.scrollLeft / tr.clientWidth); };
    var go = function (i) { i = Math.max(0, Math.min(th.length - 1, i)); tr.scrollTo({ left: i * tr.clientWidth, behavior: 'smooth' }); };
    th.forEach(function (b, i) { b.onclick = function () { go(i); }; });
    $$('.aubk-arrow', g).forEach(function (b) { b.onclick = function () { go(idx() + (+b.getAttribute('data-dir'))); }; });
    tr.addEventListener('scroll', function () {
      var k = idx();
      th.forEach(function (b, i) { b.setAttribute('aria-current', String(i === k)); });
      if (th[k]) th[k].scrollIntoView({ block: 'nearest', inline: 'nearest' });
    }, { passive: true });
  });

  /* offres : prix, prix barré et badge d'économie de l'offre choisie ; quantité envoyée au panier */
  $$('[data-aubk-buy]').forEach(function (col) {
    var now = $('[data-aubk-now]', col), was = $('[data-aubk-was]', col), save = $('[data-aubk-save]', col);
    var radios = $$('.aubk-offer input', col), btn = $('[data-aubk-atc]', col), msg = $('[data-aubk-msg]', col), cartEl = $('cart-drawer');
    var qty = 1;
    var sync = function () {
      var r = radios.filter(function (x) { return x.checked; })[0];
      if (!r) return;
      qty = +r.value;
      var total = +r.getAttribute('data-total'), full = +r.getAttribute('data-full'), pct = +r.getAttribute('data-pct');
      if (now) now.textContent = eur(total);
      if (was) { was.textContent = eur(full); was.hidden = !(full > total); }
      if (save) { save.textContent = (save.getAttribute('data-pattern') || '').replace('[pct]', pct + ' %'); save.hidden = !(pct > 0); }
    };
    radios.forEach(function (x) { x.addEventListener('change', sync); });
    sync();
    if (!btn) return;
    btn.addEventListener('click', function () {
      var body = { items: [{ id: +btn.getAttribute('data-variant'), quantity: qty }] };
      if (cartEl) { body.sections = 'cart-drawer,cart-icon-bubble'; body.sections_url = window.location.pathname; }
      btn.disabled = true;
      fetch(root + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(body) })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
        .then(function (o) {
          btn.disabled = false;
          if (!o.ok) { if (msg) msg.textContent = o.j.description || 'Impossible d’ajouter le calendrier au panier.'; return; }
          if (msg) msg.textContent = '';
          if (cartEl && typeof cartEl.renderContents === 'function') { cartEl.renderContents(o.j); cartEl.classList.remove('is-empty'); var inn = cartEl.querySelector('.drawer__inner'); if (inn) inn.classList.remove('is-empty'); if (typeof cartEl.open === 'function' && !cartEl.classList.contains('active')) cartEl.open(); }
          else window.location = root + 'cart';
        })
        .catch(function () { btn.disabled = false; if (msg) msg.textContent = 'Une erreur est survenue, réessayez.'; });
    });
  });
})();
/* barre fixe d'achat : visible une fois les offres et le bouton principal dépassés (sortis par le haut) ; son bouton fait défiler jusqu'aux offres */
(function () {
  var bar = document.querySelector('[data-aubk-sticky]'), offers = document.querySelector('.aubk-offers'), atc = document.querySelector('[data-aubk-atc]');
  if (!bar || !offers || !('IntersectionObserver' in window)) return;
  var btn = bar.querySelector('[data-aubk-sticky-btn]'), seen = new Map();
  btn.addEventListener('click', function () {
    offers.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
    var r = offers.querySelector('input:checked') || offers.querySelector('input'); if (r) r.focus({ preventScroll: true });
  });
  var io = new IntersectionObserver(function (es) {
    es.forEach(function (e) { seen.set(e.target, e.isIntersecting); });
    var show = !Array.from(seen.values()).some(Boolean) && offers.getBoundingClientRect().bottom < 0; /* seulement une fois les offres dépassées vers le bas */
    bar.classList.toggle('is-on', show); bar.setAttribute('aria-hidden', String(!show)); btn.tabIndex = show ? 0 : -1;
  });
  io.observe(offers); if (atc) io.observe(atc);
})();
/* compte à rebours de la barre du haut (heures / minutes / secondes comme la source) ; masquée une fois la date passée */
(function () {
  var el = document.querySelector('[data-aubk-timer]'); if (!el) return;
  var end = Date.parse(el.dataset.end), u = {};
  el.querySelectorAll('[data-u]').forEach(function (b) { u[b.dataset.u] = b; });
  function p(n) { return String(n).padStart(2, '0'); }
  function tick() {
    var d = end - Date.now();
    if (!(d > 0)) { el.hidden = true; clearInterval(t); return; }
    u.h.textContent = p(Math.floor(d / 36e5) % 24); u.m.textContent = p(Math.floor(d / 6e4) % 60); u.s.textContent = p(Math.floor(d / 1e3) % 60);
  }
  var t = setInterval(tick, 1000); tick();
})();

